import { render, staticRenderFns } from "./UiCalendar.vue?vue&type=template&id=36dd489d"
import script from "./UiCalendar.vue?vue&type=script&lang=js"
export * from "./UiCalendar.vue?vue&type=script&lang=js"
import style0 from "./UiCalendar.vue?vue&type=style&index=0&id=36dd489d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports